import { motion } from "framer-motion";

const journey = [
  {
    title: "React",
    subtitle: "1 year of building responsive interfaces",
    year: "2025 – 2026",
  },
  {
    title: "Freelance",
    subtitle: "Started taking client work in 2026",
    year: "2026",
  },
  {
    title: "Computer Engineering",
    subtitle: "Completed university in 2026",
    year: "2026",
  },
];

export default function Journey() {
  return (
    <section
      id="journey"
      className="bg-white py-20 text-gray-900 dark:bg-[#030712] dark:text-white sm:py-24"
    >
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 12 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.5 }}
          className="mb-12"
        >
          <p className="text-xs font-semibold uppercase tracking-[0.32em] text-emerald-500">
            Behind the code
          </p>
          <h2 className="mt-4 text-4xl font-bold tracking-tight text-gray-900 sm:text-5xl dark:text-white">
            My journey so far
          </h2>
        </motion.div>

        <div className="grid gap-10 lg:grid-cols-[0.85fr_1.15fr] lg:items-start">
          <motion.div
            initial={{ opacity: 0, y: 12 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.5 }}
            className="max-w-xl"
          >
            <p className="text-sm leading-6 text-gray-600 md:text-base dark:text-gray-400">
              A simple view of the main things worked on recently, without extra
              decoration.
            </p>

            <div className="mt-8 space-y-4 text-sm leading-7 text-gray-600 dark:text-gray-400">
              <p>• Practical work matters more than flashy presentation.</p>
              <p>• Clean structure and clear thinking stay the focus.</p>
              <p>• Freelance work is open.</p>
            </div>
          </motion.div>

          <div className="relative">
            <div className="absolute left-3 top-2 h-full w-px bg-gray-200 dark:bg-gray-800" />

            <div className="space-y-8">
              {journey.map((item, index) => (
                <motion.div
                  key={item.title}
                  initial={{ opacity: 0, x: -14 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true, amount: 0.3 }}
                  transition={{ duration: 0.45, delay: index * 0.08 }}
                  className="relative pl-10"
                >
                  <div className="absolute left-0 top-2 h-3 w-3 rounded-full bg-emerald-500" />

                  <div className="flex flex-col gap-2 sm:flex-row sm:items-start sm:justify-between">
                    <div>
                      <h3 className="text-lg font-medium text-gray-900 dark:text-white">
                        {item.title}
                      </h3>
                      <p className="mt-1 text-sm leading-6 text-gray-600 dark:text-gray-400">
                        {item.subtitle}
                      </p>
                    </div>

                    <span className="text-sm text-gray-500 dark:text-gray-400">
                      {item.year}
                    </span>
                  </div>

                  {index !== journey.length - 1 && (
                    <div className="mt-6 border-b border-gray-200 dark:border-gray-800" />
                  )}
                </motion.div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
